<button (click)="toggleMenu()" class="btn-icon-small icon i-bars menu"></button>
<div *ngIf="{ currentUser: currentUser$ | async, user: user$ | async, users: students$ | async } as obs" class="profil">
    <div class="img"></div>
    <div class="name">
        <p class="with-icon" (click)="openModalSelectUser()" *appCheckPermissions="permissions.header_can_impersonate">
            <ng-container *ngIf="obs?.currentUser?.type === 'employee'">
                Sélectionner un élève
            </ng-container>
            <ng-container *ngIf="obs?.currentUser?.type !== 'employee'">
                {{ obs?.currentUser?.firstname }} {{ obs?.currentUser?.lastname }}
            </ng-container>
        </p>

        <p *appCheckPermissions="permissions.header_cannot_impersonate">
            {{
                (obs?.currentUser?.firstname + ' ' + obs?.currentUser?.lastname).includes('null')
                    ? obs?.currentUser?.email
                    : obs?.currentUser?.firstname + ' ' + obs?.currentUser?.lastname
            }}
        </p>

        <!--RETURN TO MY USER BUTTON-->
        <!-- <ng-container *appCheckPermissions="permissions.my_account">
            <button
                (click)="selectCurrentUser(obs?.user)"
                *ngIf="obs?.currentUser && obs?.user && obs?.currentUser?.id !== obs?.user?.id"
                class="btn btn--secondary icon i-undo"
                type="button"
            >
                <span>
                    {{ 'NAV.HEADERS.RESET-CURRENT-USER-BTN' | translate }}
                </span>
            </button>
        </ng-container> -->
    </div>
</div>

<div class="header-link-container">
    <!--VIEW SCHOOL-->
    <a class="header-link" href="" (click)="openModalViewSchool()">
        <span class="header-label">{{ 'NAV.HEADERS.VIEW_SCHOOL' | translate }}</span>
        <span class="icon i-school"></span>
    </a>

    <!--SUPPORT-->
    <a class="header-link" href="" (click)="openModalSupportForm()">
        <span class="header-label">{{ 'NAV.HEADERS.SUPPORT' | translate }}</span>
        <span class="icon i-headset"></span>
    </a>
    <ng-container *appCheckPermissions="permissions.my_account">
        <a *ngIf="user$ | async as user" href="" class="header-link" (click)="openModalLoggedInProfile()">
            <span class="header-label">{{ 'NAV.HEADERS.MY_ACCOUNT' | translate }}</span>
            <span class="icon i-user"></span>
        </a>
    </ng-container>

    <!-- LOGOUT  -->
    <a
        (click)="isUserInMultipleSchools ? toggleLogoutOptions(true) : preventLogout()"
        class="header-link"
        [ngClass]="{ extended: showLogoutOptions }"
    >
        <span class="header-label">{{ 'NAV.HEADERS.LOGOUT-LINK' | translate }}</span>
        <span class="icon i-signout"></span>
    </a>
    <div class="logout-options" *ngIf="showLogoutOptions" appClickOutside (clickOutside)="toggleLogoutOptions(false)">
        <a (click)="preventSchoolChange()">{{ 'NAV.HEADERS.CHANGE_SCHOOL' | translate }}</a>
        <a (click)="preventLogout()">{{ 'NAV.HEADERS.LOGOUT-LINK' | translate }}</a>
    </div>
</div>
